exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.total-count[data-v-2a6680d4] {\n  margin-bottom: 12px;\n}\n.filters[data-v-2a6680d4] {\n  margin-bottom: 12px;\n}\n.c-file[data-v-2a6680d4] {\n  margin-top: 12px;\n}\n.submit-form-container[data-v-2a6680d4] {\n  margin-top: 12px;\n}\n.submit-button[data-v-2a6680d4] {\n  margin-top: 12px;\n  color: #fff;\n  background: #25d366;\n  width: 180px;\n  border: none;\n}\n", ""]);

// exports
